export default __webpack_public_path__ + "static/media/report-img.e03d6dfb.png";